import { analyticsLocalStorage } from '.';

const addVideoEntry = ({
  blockId,
  chapterId,
  courseId,
  currentTimestamp,
  totalViewTime,
  userId,
  viewTimes
}) => {
  const existingEntry = analyticsLocalStorage.findExistingEntry({
    type: 'video',
    userId
  });

  const data = existingEntry ? existingEntry.values.data : {};

  if (blockId in data) {
    const newViewTimes = data[blockId].viewTimes;

    const times = Object.keys(viewTimes);
    for (let i = 0; i < times.length; i++) {
      const time = times[i];
      newViewTimes[time] = viewTimes[time] + (newViewTimes[time] || 0);
    }

    const newTotalViewTime = totalViewTime + (data[blockId].totalViewTime || 0);

    data[blockId] = {
      currentTimestamp,
      viewTimes: newViewTimes,
      totalViewTime: newTotalViewTime
    };
  } else {
    data[blockId] = { currentTimestamp, viewTimes, totalViewTime };
  }

  analyticsLocalStorage.createOrUpdateEntry({
    key: existingEntry ? existingEntry.key : null,
    values: {
      data,
      type: 'video',
      chapterId,
      courseId,
      userId
    }
  });
};

export default addVideoEntry;
